import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import Logo from '#/assets/images/logo-h.png';
import { PersonIcon, ProfilePlusIcon } from '#/assets/svgs';
import { FieldError } from '#/common/components';
import { PasswordField } from '#/common/components/PasswordField';
import { Avatar, AvatarFallback, AvatarImage, Button, Input } from '#/components/ui';
import { RESET_TOKEN } from '#/utils';
import { useMemberLogin } from '..';

const MemberLogin = ({ isThriveCart = false }) => {
    const { token } = useParams();

    const {
        handleChangeInvite,
        handleSubmitInvite,
        inviteErrors,
        inviteTouched,
        inviteValues,
        setInviteValues,
        inviteMemberApiLoading,
        imagePreview,
        handleImage,
    } = useMemberLogin({ isThriveCart });

    useEffect(() => {
        if (token) {
            setInviteValues(RESET_TOKEN, token);
        }
    }, [token]);

    return (
        <div className='min-h-screen bg-grid-lines bg-cover bg-center bg-no-repeat flex items-center justify-center px-4'>
            <div className='w-full min-h-[calc(100dvh-67px)] border-lightGray sm:min-h-0 flex flex-col gap-12 justify-center items-center max-w-md bg-white rounded-2xl shadow-md px-12 py-14'>
                <img src={Logo} alt='logo' className='w-[10.625rem]' />
                <div className='flex flex-col gap-6'>
                    <div className='text-center space-y-3'>
                        <h3 className='text-secondary font-cormorant text-[2rem] font-bold'>Start Your Journey</h3>
                        <p className='text-sm font-normal leading-4 text-gray500'>
                            Enter your information to get started.
                        </p>
                    </div>

                    <form onSubmit={handleSubmitInvite} className='space-y-6 w-full'>
                        <div className='relative mx-auto w-fit'>
                            <Avatar className='w-24 h-24 border-[0.25rem] border-white shadow-lg'>
                                <AvatarImage
                                    src={imagePreview}
                                    alt={inviteValues?.firstName}
                                    className='w-full h-full object-cover rounded-full'
                                />
                                <AvatarFallback className='bg-gray50'>
                                    <PersonIcon />
                                </AvatarFallback>
                            </Avatar>

                            <label
                                htmlFor='profile-picture-input'
                                className='absolute bottom-0 left-[4.25rem] cursor-pointer'
                            >
                                <ProfilePlusIcon />
                            </label>

                            <input
                                type='file'
                                accept='image/png, image/jpeg, image/jpg'
                                id='profile-picture-input'
                                className='hidden'
                                onChange={handleImage}
                            />
                        </div>
                        <div className='flex gap-4'>
                            <div className='space-y-2'>
                                <label htmlFor='firstName' className='block text-sm font-medium text-gray700'>
                                    First Name
                                </label>
                                <Input
                                    id='firstName'
                                    name='firstName'
                                    type='text'
                                    placeholder='Enter first name'
                                    className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                    value={inviteValues?.firstName}
                                    onChange={handleChangeInvite}
                                />

                                <FieldError error={inviteTouched?.firstName && inviteErrors?.firstName} />
                            </div>
                            <div className='space-y-2'>
                                <label htmlFor='lastName' className='block text-sm font-medium text-gray700'>
                                    Last Name
                                </label>
                                <Input
                                    id='lastName'
                                    name='lastName'
                                    type='text'
                                    placeholder='Enter last name'
                                    className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                    value={inviteValues?.lastName}
                                    onChange={handleChangeInvite}
                                />

                                <FieldError error={inviteTouched?.lastName && inviteErrors?.lastName} />
                            </div>
                        </div>
                        <div className='space-y-2'>
                            <label htmlFor='password' className='block text-sm font-medium text-gray700'>
                                Password
                            </label>
                            <PasswordField
                                id='password'
                                name='password'
                                className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                value={inviteValues?.password}
                                onChange={handleChangeInvite}
                            />

                            <FieldError error={inviteTouched?.password && inviteErrors?.password} />
                        </div>
                        <div className='space-y-2'>
                            <label htmlFor='confirmPassword' className='block text-sm font-medium text-gray700'>
                                Confirm Password
                            </label>
                            <PasswordField
                                id='confirmPassword'
                                name='confirmPassword'
                                className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                value={inviteValues?.confirmPassword}
                                onChange={handleChangeInvite}
                            />

                            <FieldError error={inviteTouched?.confirmPassword && inviteErrors?.confirmPassword} />
                        </div>

                        <Button
                            type='submit'
                            disabled={inviteMemberApiLoading}
                            className='w-full h-[2.625rem] flex justify-center py-3 px-5 border border-transparent text-sm font-medium rounded-lg cursor-pointer'
                        >
                            Get Started
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export { MemberLogin };
